import classNames from 'classnames';
import React from 'react';

import commonStyles from '../../../common.module.scss';

import image from './advancedReceiving.png';

export const AdvancedReceivingVariant: React.FC = () => (
  <div>
    <img
      className={commonStyles.image}
      src={image}
      alt="Illustration of a future webpage-builder feature"
    />
    <h2 className={commonStyles.h2}>
      Receiving files from a ton of clients can get messy—until now.
    </h2>
    <p className={commonStyles.body}>
      If you’re in the business of receiving large files, we want to make things
      (even) easier.
    </p>
    <ul className={classNames(commonStyles.body, commonStyles.list)}>
      <li>Show clients a simple guide on how to send their files</li>
      <li>Choose the types of files you want clients to send</li>
      <li>Create custom forms to get the information you need</li>
    </ul>
    <p className={commonStyles.body}>
      Get notified when files are sent, and keep track of everything in one
      simple overview—you’ll always know who sent what without ever losing time
      (or files).
    </p>
    <p className={commonStyles.body}>
      While we’re cooking up this new idea, we’d love to hear from you.
    </p>
  </div>
);

AdvancedReceivingVariant.displayName = 'AdvancedReceivingVariant';
